"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicLiveSkeleton = void 0;

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../Layout");

var BasicLiveSkeleton = function BasicLiveSkeleton(_ref) {
  var color = _ref.color;
  return _react.default.createElement(_Layout.Grid, {
    gridRowGap: 3
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "180px",
    borderRadius: 3
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 2
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "100%",
    borderRadius: 3
  })));
};

exports.BasicLiveSkeleton = BasicLiveSkeleton;